import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { NXRightArrow, NXLeftArrow, NXPlus, NXDelete, NXEditPen } from "../../icons";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import CategoryModal from "./modalForm";
import useApi from "../../api";
import { getQueryVariables } from "../../utils";
import GenericSelectableTable from "../../components/selectableTable";
import { GraphQLPagination, useDeleteConfirmation } from "../../components/common";
import CategoryEditModal from "./CategoryEditModal";

import { useQuery, gql } from "@apollo/client";

const GET_CATEGORIES = gql`
    query MyQuery($first: Int, $after: String = "", $before: String = "", $isTopLevel: Boolean = true, $parent: ID = "") {
        categories(first: $first, after: $after, before: $before, isTopLevel: $isTopLevel, parent: $parent) {
            edges {
                node {
                    name
                    dbId
                    childInfo {
                        hasChild
                    }
                    parent {
                        dbId
                        name
                    }
                }
                cursor
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
`;

function CategoryTable() {
    const { handleDelete } = useDeleteConfirmation();
    const api = useApi();
    const [parent, setParent] = useState('none');
    const [iterableAsParent, setIterableAsParent] = useState<any>();
    const [categoryEdit, setCategoryEdit] = useState<any>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (!searchParams.get("first") && !searchParams.get("last")) {
          setSearchParams({ first: "20" });
        }
      }, []);


    const variables = getQueryVariables(searchParams);
    if (variables.parent) {
        variables.isTopLevel = false;
    }


    const { data, loading, error, refetch } = useQuery(GET_CATEGORIES, {
        variables: variables,
        notifyOnNetworkStatusChange: true,
      });
    

    const [openModal, setOpenModal] = useState(false)

    

   

 

    const onModalOpen = (item?: any) => {
        setOpenModal(!openModal);
        if (item) {
            onParentChange(item.node.dbId, item.node.name);
        }
    };

    const onParentChange = (id: number, name: string) =>  {
        setSearchParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            newParams.set("parent", id.toString());
            newParams.set("parentName", name);
            return newParams;
        });
    }

   
  


    const columns = [
        { header: "Name", key: "node.name", render:(item:any)=>(
            <div className="flex flex-col space-y-1">
                <p className="text-lg font-semibold text-gray-800">{item.node.name}</p>
                <p className="text-sm text-gray-500">#{item.node.dbId}</p>
            </div>
        )},
        { header: "Parent", key: "node.parent", render:(item:any)=>(
            <div>
                {item.node.parent ? (
                    <p className="text-gray-800">{item.node.parent.name}</p>
                ) : (
                    <span className="text-gray-500">--</span>
                )}
            </div>
        )},
        { header: "Action", key: "", render:(item:any)=>(
            <div className="flex gap-2">
                <button className="p-1" onClick={() => handleDelete(item.node.dbId, 'Category', api.deleteCategory, refetch)}>
                    <NXDelete />
                </button>
                <button onClick={() => setCategoryEdit(item.node.dbId)} className="p-1">
                    <NXEditPen />
                </button>
            </div>
        )},
        { header: "", key: "", render:(item:any, index:number)=>(
    
            item.node.childInfo?.hasChild ? <a key={index} className="cursor-pointer text-blue" onClick={(e) => onParentChange(item.node.dbId, item.node.name)}><NXRightArrow className="h-12" /></a> : 
            <a key={index} onClick={() => onModalOpen(item)} className="cursor-pointer text-blue-500 flex items-center">
                <NXPlus className="h-5 mr-1" /> Add Subcategory
            </a>
     
     
        )},


    ]
 

    const onBack = (e: any) => {
        e.preventDefault();
        window.history.back();
    }

    return (
        <>
            <div className="flex justify-between pl-[5%] pt-[5%] md:pl-10 md:pr-10 md:pt-10">
                <div>
                    
                <button className="text-gray-500 flex items-center gap-2" onClick={onBack}>
                    <NXLeftArrow className="h-6" />
                    Back
                </button>
                   
                </div>
                <div>
                    <button
                    className="text-white bg-primary-600 px-10 py-3 rounded-xl font-nunito font-[900]"
                    onClick={(e) => onModalOpen()}
                    >
                    {variables.parent ? "Add Subcategory of " + variables.parentName : "Add Category"}
                    </button>
                    
                </div>
                
            </div>
            
            <PageBodyWrapper>
                <div className="relative overflow-x-auto">

                    <GenericSelectableTable columns={columns} data={data?.categories?.edges || []}/>
                </div>
                <GraphQLPagination 
                    edges={data?.categories?.edges || []}
                    pageInfo={data?.categories?.pageInfo || {}}
                />
            </PageBodyWrapper>

            {openModal && <CategoryModal  isOpen={openModal} onClose={() => setOpenModal(false)} refresh={refetch} /> }
            {categoryEdit &&  <CategoryEditModal id={categoryEdit} isOpen={categoryEdit ? true : false} refresh={refetch} onClose={() => setCategoryEdit(null)} /> }
        </>
    );
}

export default CategoryTable;
